import { makeVar } from '@apollo/client';

export const makeInMemoryVar = (storageKey, defaultValue) => {
  let storedVal = window.localStorage.getItem(storageKey);
  if (storedVal) storedVal = JSON.parse(storedVal);
  const value = storedVal ? storedVal : defaultValue;
  return makeVar(value);
};

export const setInMemoryVar = (storageKey, value) => {
  return window.localStorage.setItem(storageKey, JSON.stringify(value));
};

export const clearInMemoryVar = storageKey => window.localStorage.removeItem(storageKey);

export const clearInMemoryVars = () => {
  window.localStorage.clear();
};
